"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediationAreas = exports.Areas = void 0;
var Constants_1 = require("../../Admin/LeadsManagement/shared/Constants");
exports.Areas = [
    {
        area: Constants_1.LitigationAreas.LitigationFunnelState,
        name: "Litigation Funnel State",
        stages: [
            { stage: Constants_1.LitigationStages.ServiceConfirmation, name: "Service Confirmation" },
            { stage: Constants_1.LitigationStages.ServiceOfWrittenDiscovery, name: "Service of Written Discovery" },
            { stage: Constants_1.LitigationStages.DiscoveryProcessPRequestsToD, name: "Discovery Process: P Requests to D" },
            { stage: Constants_1.LitigationStages.PreparePostDiscoveryCaseEvaluationMemo, name: "Prepare Post-Discovery Case Evaluation Memo" },
        ],
    },
    {
        area: Constants_1.LitigationAreas.DiscoveryResponses,
        name: "Discovery Responses",
        stages: [
            { stage: Constants_1.LitigationStages.DiscoveryProcessPResponsesToD, name: "Discovery Process: P Responses to D" },
        ],
    },
    {
        area: Constants_1.LitigationAreas.DefendantsDeposition,
        name: "Defendant's Deposition",
        stages: [
            { stage: Constants_1.LitigationStages.DefendantsDeposition, name: "Defendant's Deposition" },
        ],
    },
    {
        area: Constants_1.LitigationAreas.PlaintiffDepo,
        name: "Plaintiff’s Deposition",
        stages: [
            { stage: Constants_1.LitigationStages.PlaintiffsDeposition, name: "Plaintiff’s Deposition" },
            { stage: Constants_1.LitigationStages.ObtainDepositionTranscript, name: "Obtain Deposition Transcript" },
        ],
    },
    {
        area: Constants_1.LitigationAreas.Pleadings,
        name: "Pleadings",
        stages: [
            { stage: Constants_1.LitigationStages.Pleadings, name: "Pleadings" },
        ],
    },
    {
        area: Constants_1.LitigationAreas.CaseManagementConference,
        name: "CMC",
        stages: [
            { stage: Constants_1.LitigationStages.PleadingCaseManagementConference, name: "CMC" },
        ],
    },
    {
        area: Constants_1.LitigationAreas.Manual,
        name: "Manual",
        stages: [
            { stage: Constants_1.LitigationStages.Manual, name: "Manual" },
        ],
    },
    {
        area: Constants_1.LitigationAreas.OutsideTrigger,
        name: "Outside Trigger",
        stages: [
            { stage: Constants_1.LitigationStages.DiscoveryRequestSet2, name: "Discovery Request Set 2" },
            { stage: Constants_1.LitigationStages.DiscoveryRequestSet3, name: "Discovery Request Set 3" },
            { stage: Constants_1.LitigationStages.MotionToCompel, name: "Motion to Compel" },
            { stage: Constants_1.LitigationStages.ResponseToOppositionToMotion, name: "Response to Opposition to Motion" },
            { stage: Constants_1.LitigationStages.DepositionObjection, name: "Deposition Objection" },
            { stage: Constants_1.LitigationStages.PleadingsNoResponseFromDefendant, name: "Pleadings: No Response from Defendant" },
            { stage: Constants_1.LitigationStages.DemurrerOpposition, name: "Demurrer Opposition" },
            { stage: Constants_1.LitigationStages.InitialTrialSettingConferenceTSC, name: "Initial Trial Setting Conference (TSC)" }
        ],
    },
    {
        area: Constants_1.LitigationAreas.OutsideSingle,
        name: "Outside Single",
        stages: [
            { stage: Constants_1.LitigationStages.ServeInitialDisclousureDemand, name: "Serve Initial Disclosure Demand" },
            { stage: Constants_1.LitigationStages.NegotiationsLitigationArbitration, name: "Negotiations / Litigation / Arbitration" },
        ],
    },
];
exports.MediationAreas = [
    {
        area: Constants_1.LitigationAreas.Mediation,
        name: "Mediation",
        stages: [
            { stage: Constants_1.LitigationStages.SendListOfMediatorsToOC, name: "Send List of Mediators to OC" },
            { stage: Constants_1.LitigationStages.ConfirmOrFollowUpWithOCOnMediatorSelection, name: "Confirm or Follow Up with OC on Mediator Selection" },
            { stage: Constants_1.LitigationStages.ResearchAndUpdateMediatorInformation, name: "Research and Update Mediator Information" },
            { stage: Constants_1.LitigationStages.RequestDatesFromMediator, name: "Request Dates from Mediator" },
            { stage: Constants_1.LitigationStages.SendProposedMediationDatesToClientAndToOC, name: "Send Proposed Mediation Dates to Client and to OC" },
            { stage: Constants_1.LitigationStages.ConfirmMediationDateWithTheOpposingCounselAndScheduleIt, name: "Confirm Mediation Date with the Opposing Counsel and Schedule it" },
            { stage: Constants_1.LitigationStages.SendAndSignMediationNotice, name: "Send and Sign Mediation Notice" },
            { stage: Constants_1.LitigationStages.ObtainAndCalendarMediationDeadlines, name: "ENTER DATES IN CUSTOM FIELD - Obtain and Calendar Mediation Deadlines" },
            { stage: Constants_1.LitigationStages.DraftMediationBrief, name: "Draft Mediation Brief" },
            { stage: Constants_1.LitigationStages.ReviewOfMediationBrief, name: "Review of Mediation Brief" },
            { stage: Constants_1.LitigationStages.SubmitMediationBrief, name: "Submit Mediation Brief" },
            { stage: Constants_1.LitigationStages.ScheduleMediationPrepCall, name: "Schedule Mediation Prep Call" },
            { stage: Constants_1.LitigationStages.AttendMediation, name: "Attend Mediation" },
            { stage: Constants_1.LitigationStages.ProvidePostMediationFeedbackOnMediator, name: "Provide Post-Mediation Feedback on Mediator" },
        ],
    },
];
//# sourceMappingURL=Areas.js.map